export default __webpack_public_path__ + "static/media/flag-af.d2f04a4e.svg";